const renderCurrentOpenStatus = location => {
  if (location.open) {
    if (!location.accepting_orders || !location.is_order_ahead_enabled) {
      return 'Unable to accept orders at the moment';
    }
    const dayOfWeekString = new Date()
      .toLocaleString('en-us', {weekday: 'long'})
      .toLowerCase();
    return `Open ${location.ordering_hours[dayOfWeekString][0]}`;
  } else {
    return 'Closed';
  }
};

export default renderCurrentOpenStatus;
